module.exports = __webpack_public_path__ + "cd0ef6b527e4a8ec16bf4f64979975fa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/popcorn.png
// module id = 2421
// module chunks = 0